import React from 'react';
import PageTemplate from '../components/PageTemplate';

const ProductsOverview = () => {
  return (
    <PageTemplate title="Products Overview">
      {/* Add your content here */}
    </PageTemplate>
  );
};

export default ProductsOverview;
